import { Component, Input } from '@angular/core';

// A single top-of-dashboard alert, shown collapsed by default as a count badge.
// Clicking the header expands it to list the item names. The irrigation
// "events left on" alert uses the loading flag to show a spinner while its
// background check is still running (there is no count yet in that state).
@Component({
  standalone: false,
  selector: 'dashboard-alert-badge',
  templateUrl: './dashboard-alert-badge.component.html',
  styleUrls: ['./dashboard-alert-badge.component.scss']
})
export class DashboardAlertBadgeComponent {
  @Input() title = '';
  @Input() items: string[] = [];
  @Input() loading = false;

  expanded = false;

  get count(): number {
    return this.items?.length ?? 0;
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
